import { useTranslation } from 'react-i18next';
import { useAuth } from "../../modules/authentication/AuthProvider";
import { Card, Button } from "react-daisyui";

const AuthenticationScreen: React.FC<{ children: React.ReactNode, title: string }> = ({ children, title }) => {
    const { t } = useTranslation();
    const { signInWithGoogle } = useAuth();

    return (
        <div className="relative min-h-screen w-full flex items-center justify-center p-5">
            <div className="absolute inset-0 bg-cover bg-center opacity-15 z-[-1]" style={{backgroundImage: 'url("/app/bg-gradient.png")'}} />
            <Card className="w-full max-w-[800px] p-8 shadow-lg bg-white bg-opacity-90">
                <div className="flex flex-col sm:flex-row gap-6 h-full">
                    <div className="flex-1">
                        <div className="flex flex-row sm:flex-col items-center justify-center sm:justify-center w-full">
                            <img src="/app/logo.svg" alt="FindMeinZuhause.de Logo" className="w-30 h-auto" />
                        </div>
                        <div className="flex flex-col h-full">
                            <h2 className="text-2xl font-bold mb-2">{t('authentication.authenticationScreen.welcome')}</h2>
                            <p className="text-sm mb-4">
                                {t('authentication.authenticationScreen.signInMessage')}
                            </p>
                            <div className="flex flex-col gap-2 mb-4">
                                {t('authentication.authenticationScreen.features', { returnObjects: true }).map((feature, index) => (
                                    <div key={index} className="flex items-center gap-2">
                                        <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                                        <span className="text-sm">{feature}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="flex-1">
                        <div className="flex justify-center items-center h-full">
                            <div className="flex flex-col gap-3 w-full">
                                <Button onClick={async () => await signInWithGoogle()} variant="outline">
                                    {t('authentication.authenticationScreen.signInWithGoogle')}
                                </Button>

                                <div className="flex items-center gap-2">
                                    <hr className="flex-grow border-gray-300" />
                                    <span className="text-sm">{t('authentication.authenticationScreen.or')}</span>
                                    <hr className="flex-grow border-gray-300" />
                                </div>

                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
};

export default AuthenticationScreen;
